import {
  AccountingConnectionPartner,
  AccountingConnectionStatus,
  AccountingConnectionSyncState
} from "@wingspanhq/wingspan-api-sdk";
import { queriesAccountingConnections } from "@query";
import { useFeatureFlags } from "../../../query/hooks/useFeatureFlags";
import React, { useState } from "react";
import { WSQueries } from "../../../query/WSQuery";
import { useQueriesOn } from "../../../shared/hooks/useQueriesOn";

export const QuickbooksWrapper: React.FC = props => {
  const qAccountingConnections =
    queriesAccountingConnections.listAccountingConnections.useQuery({
      filter: { partner: { eq: AccountingConnectionPartner.QUICKBOOKS } }
    });
  const qFeatureFlags = useFeatureFlags();
  const [render, setRender] = useState(false);

  useQueriesOn(
    "successAll",
    () => {
      setTimeout(() => setRender(true), 100);
    },
    qAccountingConnections,
    qFeatureFlags
  );

  return (
    <WSQueries
      queries={{
        qAccountingConnections,
        qFeatureFlags
      }}
      renderErrors={() => null}
      renderLoader={() => null}
    >
      {({ qAccountingConnections, qFeatureFlags }) => {
        const hasSyncedConnection = (
          qAccountingConnections.data.data || []
        ).some(
          connection =>
            connection.status === AccountingConnectionStatus.CONNECTED &&
            connection.syncState === AccountingConnectionSyncState.SYNCED
        );

        const isQuickbooksActive =
          qFeatureFlags.data.qboOnboarding &&
          (qFeatureFlags.data?.forceShowQBO || hasSyncedConnection);

        if (render && isQuickbooksActive) {
          return <>{props.children}</>;
        }

        return null;
      }}
    </WSQueries>
  );
};
